import { BOOKING_WINDOW_DESCRIPTION } from "@app/analytics/Calendar/constants";
import type {
  SchedulingLinkBookingWindow,
  SchedulingLinkDuration,
} from "@app/common/types";

const MEETING_DURATION_OPTIONS: SchedulingLinkDuration[] = [15, 30, 60, 90];

export const MEETING_DURATION_DROPDOWN_ITEMS: {
  value: string;
  label: string;
}[] = MEETING_DURATION_OPTIONS.map((value) => ({
  value: `${value}`, // needs to be a string value for the dropdown
  label: `${value} minutes`,
}));

export const BOOKING_WINDOW_OPTIONS: {
  value: SchedulingLinkBookingWindow;
  label: string;
}[] = Object.entries(BOOKING_WINDOW_DESCRIPTION).map(([value, label]) => ({
  value: value as SchedulingLinkBookingWindow,
  label,
}));
